module.exports = __webpack_public_path__ + "static/assets/a06e319ae207748838ffbc7df435a33b.svg";